// One emoji, drawn the Apple way (EmojiGlyph.swift's EmojiGlyphView): the glyph when the table has
// one (skin-tone variants included), the server's image for a custom emoji, and `:name:` as text
// only when neither exists — never a blank square.
import { memo } from 'react';
import { EmojiPicker } from '../../../core/emojiPicker';
import { mediaUrls } from '../../media';

export type CustomEmojiMap = Readonly<Record<string, { id: string }>>;

export const EmojiGlyph = memo(function EmojiGlyph({ name, custom, className }: { name: string; custom?: CustomEmojiMap; className?: string }) {
  const char = EmojiPicker.glyph(name);
  if (char) return <span className={className ?? 'emoji-glyph'}>{char}</span>;
  const record = custom?.[name];
  if (record) return <img className={`custom-emoji ${className ?? 'emoji-glyph'}`} src={mediaUrls.customEmoji(record.id)} alt={`:${name}:`} loading="lazy" decoding="async" draggable={false} />;
  return <span className={className ?? 'emoji-glyph'}>{`:${name}:`}</span>;
});
